import { Grid, HStack, Stack, Text } from "@chakra-ui/react";
import { Slider } from "@chakra-ui/react";
import * as React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import { StepContent } from "./step-content";
import { OptimizationFormData } from "./types";

const weightFields = [
  { name: "customFopWeight", label: "First-Order Profit" },
  { name: "customCltvWeight", label: "Future Value" },
  { name: "customCltpWeight", label: "Future Profit" },
] as const;

type WeightFieldName = (typeof weightFields)[number]["name"];

export function CustomStep() {
  const { setValue, control } = useFormContext<OptimizationFormData>();
  const fieldNames = weightFields.map((f) => f.name) as WeightFieldName[];
  const values = useWatch({ control, name: fieldNames });

  return (
    <StepContent
      title="Custom Builder"
      subtitle="Assign weights to each factor"
    >
      <Stack gap="4">
        <Grid templateColumns="repeat(2, 1fr)" gap="4">
          {weightFields.map((field) => (
            <Controller
              key={field.name}
              name={field.name}
              control={control}
              defaultValue={0.25}
              render={({ field: { value } }) => (
                <Stack>
                  <HStack justify="space-between">
                    <Text>{field.label}</Text>
                    <Text>{Math.round(value * 100)}%</Text>
                  </HStack>
                  <Slider.Root
                    min={0}
                    max={1}
                    step={0.01}
                    value={[value]}
                    onValueChange={({ value: v }: { value: number[] }) => {
                      setValue(field.name, v[0]);
                    }}
                  >
                    <Slider.Control>
                      <Slider.Track>
                        <Slider.Range />
                      </Slider.Track>
                      <Slider.Thumbs />
                    </Slider.Control>
                  </Slider.Root>
                </Stack>
              )}
            />
          ))}
        </Grid>
        <HStack justify="flex-end">
          <Text fontWeight="bold">
            Total: {Math.round(values.reduce((a, b) => a + b, 0) * 100)}%
          </Text>
        </HStack>
      </Stack>
    </StepContent>
  );
}
